import { render, staticRenderFns } from "./location.vue?vue&type=template&id=501b7679&scoped=true&"
import script from "./location.vue?vue&type=script&lang=js&"
export * from "./location.vue?vue&type=script&lang=js&"
import style0 from "./location.vue?vue&type=style&index=0&id=501b7679&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b7679",
  null
  
)

export default component.exports